export { ErrorName as StoreErrorName } from './types'
export type { StoreError } from './types'

export { titleForError } from './texts'
